export default __webpack_public_path__ + "c11b0daef4c63d865e0b02a2cedef1e0.png";